import {z} from 'zod';

import {deriveCriticalStatus, isImagesetCriticalModule, projectStatusesSchema} from './projectStatus';
import {slimUserSchema} from './slimUserSchema';

export const imagesetSchema = z
  .object({
    id: z.string(),
    statuses: projectStatusesSchema,
    imageCount: z.number(),
    created: z.coerce.date(),
    createdBy: slimUserSchema.nullable(),
  })
  .transform((data) => ({...data, status: deriveCriticalStatus(data.statuses, isImagesetCriticalModule)}));

export const imagesetsSchema = imagesetSchema.array();
